/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-expressions */
import React from "react";
import { connect } from "react-redux";
import Hidden from "@material-ui/core/Hidden";

import GridList from "./GridList";
import { templateStrings } from "../../../Constant";
import { PageWrapper } from "../../../shared/layout";
import { roles, CityWiseId } from "../../../lib/constants";
import DayWiseCollectionList from "./DayWiseCollectionList";
import { style2 as useStyles } from "../../../styles/makeStyles";
import VehicleWiseCollectionList from "./VehicleWiseCollectionList";
import NavFilter from "../../../shared/widgets/navFilter/navFilter";
import { selectDateFilter } from "../../../redux/actions/dateFilterAction";
import { selectedOperationType } from "../../../redux/actions/operationTypeAction";
import { collectionSummaryAction } from "../../../redux/action-creators/collectionActionCreator";
import {
  BarLoader,
} from "../../../shared/widgets";

import "./collection.css";
import ButtonToolbarRangePicker from "../../../shared/components/commonComponents/ButtonToolbarRangePicker";
import HiddenSearchBar from "../../../shared/components/commonComponents/HiddenSearchBar";
import CollectionTabs from "../../../shared/components/commonComponents/CollectionTabs";

const handleDatesChange = (dates, selectDateFilterProp) => {
  if (dates.startDate && dates.endDate) {
    const fromDate = parseFloat(new Date(dates.startDate).getTime());
    const toDate = parseFloat(new Date(dates.endDate).getTime());
    selectDateFilterProp({ fromDate, toDate });
  }
};

const updateCollectionGrid = (props, cityFilter, content, user) => {
  const gridItemsData = content;
  let collectionGridStrings = templateStrings.collectionGridItems;
  let gridType = "collectionGridItems";
  if (
    props
    && cityFilter
    && (cityFilter.toString() === CityWiseId.Bhopal
      || cityFilter.toString() === CityWiseId.Indore)
  ) {
    collectionGridStrings = templateStrings.bhopalCollectionGridItems;
    gridType = "bhopalCollectionGridItems";
  }

  if (user?.role === roles?.cityManager
      || user?.role === roles?.admin || props?.user?.role === roles?.superAdmin
      || user?.role === roles?.finance
  ) {
    if (
      props
      && cityFilter
      && cityFilter.toString() === CityWiseId.Indore
    ) {
      collectionGridStrings = templateStrings.IndoreBasedCollectionGridItems;
      gridType = "IndoreBasedCollectionGridItems";
    } else {
      collectionGridStrings = templateStrings.roleBasedCollectionGridItems;
      gridType = "roleBasedCollectionGridItems";
    }
  }

  if (
    user?.cityIds?.includes(CityWiseId.Mumbai)
    && user.role === roles.agencyManager
  ) {
    collectionGridStrings = JSON.parse(JSON.stringify(collectionGridStrings));
    delete collectionGridStrings.averageBuses;
  }

  return { gridItemsData, collectionGridStrings, gridType };
};

function CollectionList(props) {
  const {
    collectionLoader, fetchCollectionSummary, operatorFilter, cityFilter,
    selectedDateFilter, selectedOperation, content, user, operationType, refreshUpliftStatus,
    selectedOperationType: selectedOperationTypeProp,
    selectDateFilter: selectDateFilterProp,
  } = props;
  const classes = useStyles();
  const [value, setValue] = React.useState("vehicle");
  const [searchString, setSearchString] = React.useState("");

  const [selectOperationList, setSelectOperationList] = React.useState([]);
  const [operationHeader, setOperationHeader] = React.useState("All");

  const isLoading = React.useMemo(
    () => collectionLoader,
    [collectionLoader],
  );

  React.useEffect(() => {
    selectedOperationTypeProp("");
  }, []);

  React.useEffect(() => {
    fetchCollectionSummary(
      {
        operatorFilter,
        cityFilter,
        dateFilter: selectedDateFilter,
        operationType: selectedOperation,
      },
      "collectionLoader",
    );
  }, [
    operatorFilter,
    cityFilter,
    selectedDateFilter,
    selectedOperation,
  ]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleSearchChange = (e) => {
    setSearchString(e);
  };

  // eslint-disable-next-line no-shadow
  const handleOperationTypeSelection = async (operationTypeProp) => {
    if (operationTypeProp === "All") {
      selectedOperationTypeProp("");
    } else {
      selectedOperationTypeProp(operationTypeProp);
    }
  };

  const setHeader = (source, header) => {
    source === "operationType" && setOperationHeader(header);
  };

  const setSelected = (source, data) => {
    source === "operationType" && setSelectOperationList(data);
  };

  const { gridItemsData, collectionGridStrings, gridType } = updateCollectionGrid(
    props,
    cityFilter,
    content,
    user,
  );

  return (
    <div className={classes.root}>
      <PageWrapper>
        {/* <HiddenRangePicker
          handleDatesChange={handleDatesChange}
          fromDate={selectedDateFilter.fromDate}
          toDate={selectedDateFilter.toDate}
          pickerClasses={classes.picker}
        /> */}
        <PageWrapper.Header heading="Overview" hideS>
          <div className="pull-right">
            <NavFilter
              source="operationType"
              options={operationType}
              selected={selectOperationList}
              setSelected={setSelected}
              onMenuSelection={handleOperationTypeSelection}
              setHeader={setHeader}
              filterHeader={operationHeader || "All"}
            />
          </div>
          <Hidden only={["sm", "xs"]}>
            {refreshUpliftStatus && (
              <div className="pull-right">
                <div className="progress-heading">
                  <span>{refreshUpliftStatus}</span>
                </div>
              </div>
            )}
            <div className="pull-right z-index-10">
              <ButtonToolbarRangePicker
                handleDatesChange={(dates) => handleDatesChange(dates, selectDateFilterProp)}
                fromDate={selectedDateFilter.fromDate}
                toDate={selectedDateFilter.toDate}
              />
            </div>
          </Hidden>
        </PageWrapper.Header>
        <PageWrapper.Body>
          <div className="custom-grid-layout">
            {Object.keys(collectionGridStrings).map((column, index) => (
              <div key={index} className="custom-grid">
                <GridList
                  isLoading={isLoading}
                  value={gridItemsData[column]}
                  gridItemsData={gridItemsData}
                  template={column}
                  type={gridType}
                />
              </div>
            ))}
          </div>
          <div>
            <PageWrapper.Header hideS removeUpperHeader isHeaderFixed={false}>
              <div className="dataTables_length tabWrapper scroll-tab">
                <CollectionTabs value={value} handleChange={handleChange} />
              </div>
              <HiddenSearchBar
                value={value}
                check="vehicle"
                placeHolder="Search Vehicle"
                handleSearchChange={handleSearchChange}
                hiddenFor={["lg", "xl", "md"]}
                classes="tabWrapper"
              />
              <HiddenSearchBar
                value={value}
                check="vehicle"
                placeHolder="Search Vehicle"
                handleSearchChange={handleSearchChange}
                hiddenFor={["sm", "xs"]}
                classes="pull-right search-container"
              />
            </PageWrapper.Header>
          </div>
          <div>
            <BarLoader scope="header" />
            {value === "vehicle" ? (
              <VehicleWiseCollectionList searchString={searchString} />
            ) : (
              <DayWiseCollectionList />
            )}
          </div>
        </PageWrapper.Body>
      </PageWrapper>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    content: state.Collection.collectionSummary,
    cityFilter: state.Cities.selectedCity,
    collectionLoader: state.loadingBar && state.loadingBar.collectionLoader,
    user: state && state.Auth && state.Auth.user,
    operatorFilter: state.Operators.selectedOperator,
    selectedDateFilter: state.DateFilter.selectedDateFilter,
    refreshUpliftStatus: state && state.Contracts && state.Contracts.refreshUpliftStatus,
    operationType: state.OperationType.operationType,
    selectedOperation: state.OperationType.selectedOperationType,
  };
}

const mapDispatchToProps = (dispatch) => ({
  fetchCollectionSummary: (params, loaderScope) => {
    dispatch(collectionSummaryAction(params, loaderScope));
  },
  selectDateFilter: (value) => {
    dispatch(selectDateFilter(value));
  },
  selectedOperationType: (params) => {
    dispatch(selectedOperationType(params));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(CollectionList);
